import {
  GtmDataLayerEvent,
  gtmDataLayerPushRaw,
} from "@made-people/grease-gtm";
import { FrontendContextV1 } from "@made-people/nestjs-bff-service";
import { Country } from "@made-people/grease-countries-and-languages";

/**
 * Push data to GTM data layer including all the MM specific global fields
 */
export function gtmDatalayerPusher(
  data: GtmDataLayerEvent,
  countries: Country[],
  frontendContext: FrontendContextV1,
) {
  if (typeof window === "undefined") {
    return;
  }

  const baseUrl = new URL("/", document.location.href).toString();

  const sharedFields = {
    baseUrl,
    language: frontendContext.language,
    country:
      countries.find(
        (country) => country.countryCode === frontendContext.country,
      )?.name ?? frontendContext.country,
  };

  const mergedData: GtmDataLayerEvent = {
    ...sharedFields,
    ...data,
  };

  if (data.ecommerce) {
    // Currency code is only needed for ecommerce events
    mergedData.ecommerce = {
      currencyCode: frontendContext.currencyCode,
      ...data.ecommerce,
    };
  }

  gtmDataLayerPushRaw(mergedData);
}
